<template>
    <div class="main-container">
      <div class="headerClass">
        <tl-header type="h1">
          <div class="main-header">Voluntary Provident Fund(VPF) declaration</div>
        </tl-header>
      </div>
      <div class="permission-alert-msg" v-show="showErrorMessage">
              VPF Declare amount must be lesser than VPF eligibility
              value RS{{eightyEightPercentOF_basic_DA}}.
            </div>
            <div class="permission-alert-msg" v-show="showPercentageError">
              VPF Declare amount must be lesser than or equal to 88%
            </div>
            <pop-up-message
            v-if="showSuccessMsg"
            :message="successMessage"
            btnText="Back"
            @back="backFromPopUp()"
          />
          <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
      <div class="heading">
            <p><b>Employee's Contribution Type</b><small class="color"> *</small></p>
      </div>
      <div class="uploadMethoRadio">
              <tl-radio
                name="uploadType"
                label="Percentage"
                id="Percentage"
                value="percentage"
                v-model="radioValue"
              />
              <tl-radio
                name="uploadType"
                label="Fixed"
                id="Fixed"
                value="fixed"
                v-model="radioValue"
              />
            </div>
      <div class="contributionHeading">
        <div>
          <div class="heading">
            <p><b>Employee's Contribution</b><small class="color"> *</small></p>
          </div>
  
          <div class="buttonGroup">
            <span v-if="radioValue == 'percentage'" class="content">{{ validateText }}</span>
            <div v-if="radioValue == 'fixed'">
              <txt
              autofocus="autofocus"
              v-numeric-only
              type="text"
              data-vv-as="name"
              name="vps_name"
              v-model="validatedValue"
              @change="valueValidationFunction(val)"
              :classname="errors.has('vps_name')"
              :errormsg="errors.first('vps_name')"
            />
            </div>
            <txt
              v-if="radioValue == 'percentage'"
              autofocus="autofocus"
              v-numeric-only
              type="text"
              data-vv-as="name"
              name="vps_name"
              v-maxchars="2"
              v-model="validatedValue"
              @change="valueValidationFunction(val)"
              :classname="errors.has('vps_name')"
              :errormsg="errors.first('vps_name')"
            />
            <span class="inputContent">Per Month</span>
          </div>
        </div>
      </div>
      <bottom-action-container class="placeAtEnd">
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="previousPage()" />
            <btn :disabled="showErrorMessage || showPercentageError" text="Save" type="primary" @click="updateVpfData()" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </template>
  <script>
import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        validateText:"% of Basic + DA",
        radioValue:"percentage",
        validatedValue:"",
        empBasicSalary:0,
        empDA:0,
        eightyEightPercentOF_basic_DA :0,
        showErrorMessage :false,
        showSuccessMsg :false,
        successMessage :"",
        showPercentageError:false,
        payloadData:{},
        toast:false,
        errmsg:""
        
      };
    },
    mounted(){
      this.fetchAllVpfData()
    },

    computed:{
      empId(){
      return localStorage.getItem("empId")
    },
    },
    methods:{
      ...mapActions({
        act_instance_post:"dashboard/vpf/updateVpsData",
        act_instance_get:"dashboard/vpf/fetchAllVpsData"
      }),
      backFromPopUp() {
       this.showSuccessMsg = false;
       this.refresh();
       },
      async valueValidationFunction(){
         if(this.radioValue == "percentage" && this.validatedValue >88 ){
          this.showPercentageError =true
         }
         else{
          this.showPercentageError =false
         }
         if(this.validatedValue <= this.eightyEightPercentOF_basic_DA && this.radioValue == "fixed"){
            this.showErrorMessage =false
         }
         else if(this.radioValue == "percentage"){
          this.showErrorMessage =false
         }
         else{
          this.showErrorMessage = true
         }
      },
       async updateVpfData(){
         try{
          const date = new Date()
         let fullDate=(date.getMonth()+1) +"-"+ date.getDate() +"-"+ date.getFullYear()
         if(this.radioValue == "percentage"){
          this.payloadData={
           employee_id:this.empId,
           type:this.radioValue,
           value:this.validatedValue,
           declaration_date:fullDate
          }
         }else{
           this.payloadData={
           employee_id:this.empId,
           type:this.radioValue,
           value:this.validatedValue,
           declaration_date:fullDate
       }
      }
           let res = await this.act_instance_post(this.payloadData)
           if(res.status){
             this.showSuccessMsg = true
             this.successMessage = res.data.message
           }
         }catch(err){
           this.toast = true
           this.errmsg = err
         }
       },
       async fetchAllVpfData(){
         try{
           const payloadData={
           employee_id:this.empId,
       }
           let res = await this.act_instance_get(payloadData)
       
           if(!res.data.payload["NPS Data"][0]){
            this.radioValue ="percentage"
            this.empBasicSalary = res.data.payload.SalaryComponents[0].value
           this.empDA = res.data.payload.SalaryComponents[1].value
           this.basic_DA = ((this.empBasicSalary + this.empDA)/100)
           let value_validated_with_percentage = ((this.empBasicSalary + this.empDA)/100)*88
           this.eightyEightPercentOF_basic_DA = value_validated_with_percentage
           }
           else{
           this.radioValue =res.data.payload["NPS Data"][0].type
           if(res.data.payload["NPS Data"][0].type == 'percentage'){
          this.validatedValue = res.data.payload["NPS Data"][0].percentage
              }
          else{
          this.validatedValue = res.data.payload["NPS Data"][0].value
           }
           this.empBasicSalary = res.data.payload.SalaryComponents[0].value
           this.empDA = res.data.payload.SalaryComponents[1].value
           this.basic_DA = ((this.empBasicSalary + this.empDA)/100)
           let value_validated_with_percentage = ((this.empBasicSalary + this.empDA)/100)*88
           this.eightyEightPercentOF_basic_DA = value_validated_with_percentage
          }
         }catch(err){
          this.toast = true
           this.errmsg = err
         }
       }
    }
  };
  </script>
  <style lang="scss" scoped>
  @import "@/scss/components/margins.scss"; //margins

  /* .mainHeading {
    font-weight:550;
    color:rgba(18, 18, 20,0.690);
    font-style:inherit
  } */
  .contributionHeading{
      display: flex;
      flex-direction: column;
      gap: 35px;
  }
  .heading {
    margin-bottom: -5px;
  }
  .heading2{
   margin-bottom: -10px;   
  }
  .dropdownDiv{
      width: 30%;
  }
  .buttonGroup {
    display: flex;
    margin-left:25px
  }
  .content {
    border-style: solid;
    border-radius: 5px;
    border-width: 2px;
    border-color: rgb(168, 232, 228);
    padding-left: 15px;
    padding-top: 5px;
    padding-right: 20px;
    // background-color: rgba(245, 244, 253);
  }
  .contributionEnds {
      margin-top: -5px;
    display: flex;
    align-items: center;
  }
  .dropdowncontent {
    padding-top: 10px;
  }
  .inputContent {
    padding-top: 8px;
  }
  .alligning {
    padding-left: 10px;
  }
  .color {
    color: red;
  }
  .uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
  margin-left: 25px;
}
.heading {
    margin:15px 15px;
  }
  </style>
  